import MyInput from '@/components/UI/MyInput';


export default [
	MyInput
]